<div class="sidebar-logo-item" (click)="showVersionDialog()">
  <img
    class="sidebar-logo__img"
    [src]="sidebarLogo"
    [appImgFallback]="fallbackLogo"
    alt="logo"
  />
</div>
